<template>
    <v-container fluid class="fill-height">
        <v-row justify="center">
            <v-col>
                <v-card class="mx-auto my-6" max-width="400">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Login</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="login">
                            <v-text-field v-model="username" name="username" label="Username" type="text"
                                placeholder="username" required></v-text-field>
                            <v-text-field v-model="password" name="password" label="Password" type="password"
                                placeholder="password" required ></v-text-field>
                            <v-btn type="submit" class="mt-4" color="primary" value="log in">Login</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackbar" >{{ apiFailed }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import Account from '../services/Account'
import { useStore } from '../services/store'


export default {
    name: "AccountLogin",
    data() {
        return {
            username: "",
            password: "",
            apiFailed: "",
            timeout: 2000,
            snackbar: false,
            rules: {
                counter: () => { console.log(this.apiFailed); return this.apiFailed; }
            }
        };
    },
    methods: {
        login() {
            const store = useStore();
            Account.requestToken({ username: this.username, password: this.password })
            .then((response) => {
                this.apiFailed = '';
                if(response.data) {
                    localStorage.setItem('access_token', response.data.access_token);
                    localStorage.setItem('refresh_token', response.data.refresh_token);
                    store.organization = 0;
                    this.$router.push('home')
                }
            })
            .catch((error) => {
                if(error.response.data) {
                    this.apiFailed = error.response.data.error_message;
                }
                else {
                    this.apiFailed = 'Login failed!';
                }
                this.snackbar = true;
            });
        },
    },
};
</script>